import { useCallback, useMemo, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '~/store/actions';
import { useAccountChange } from '~/hooks';
import { AgentStatusContext } from '~/providers/AgentStatusProvider';

export default function useChangeAccount() {
  // HOOKS
  const setAccountChange = useAccountChange();
  const dispatch = useDispatch();

  // SELECTORS
  const sipAuth = useSelector(
    state => state.phone && state.phone.sipCredentials
  );
  const sipAuthMemo = useMemo(() => sipAuth && sipAuth, [sipAuth]);

  // CONTEXT'S
  const { restartAgentStatusWS } = useContext(AgentStatusContext);

  const changeAccount = useCallback(
    async account => {
      const newSipAccount = `${account}-${sipAuthMemo?.extension}`;

      await dispatch(actions.unRegisterSession());
      dispatch(actions.disconnectWebSocket());
      await setAccountChange(account);
      await dispatch(actions.changeCredentials(newSipAccount));
      await dispatch(actions.fetchExtensions());
      await dispatch(actions.fetchAccountInfo());
      // dispatch(actions.registerSession());
      dispatch(actions.startUA());
      await dispatch(actions.getContacts('All'));
      await dispatch(actions.getContacts('Personal'));
      await dispatch(actions.getConnectedIntegrations());
      setTimeout(() => {
        // dispatch(actions.connectWebSocket(true));
        // dispatch(actions.refreshWebSocket());
        restartAgentStatusWS();
      }, 2000);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sipAuthMemo, dispatch, setAccountChange]
  );

  return changeAccount;
}
